import { css } from '@emotion/react'
import { Heading, isEmpty, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Text, VFlow } from 'bold-ui'
import { TableBox } from 'components/table'
import { TemaReuniaoEnum } from 'graphql/types.generated'
import { IdadeOrigemAtendimento } from 'view/atendimentos/detail/historico/model/model-historico'
import { mountInfosAdministrativasAtividadeColetiva } from 'view/atendimentos/detail/historico/utils/utils-historico'
import { temaReuniaoRecord, tipoAtividadeRecord } from 'view/atividade-coletiva/model-atividadeColetiva'

import HistoricoGapPanel from '../../HistoricoGapPanel'
import { HistoricoAtividadeColetivaReuniaoModel } from '../model-historicoAtividadeColetiva'

interface HistoricoAtividadeColetivaPanelReuniaoProps {
  readonly atividadeColetiva: HistoricoAtividadeColetivaReuniaoModel
  readonly idadeOrigemAtendimento: IdadeOrigemAtendimento
}

export default function HistoricoAtividadeColetivaPanelReuniao({
  atividadeColetiva,
  idadeOrigemAtendimento,
}: HistoricoAtividadeColetivaPanelReuniaoProps) {
  const hasTemaDiscussaoDeCaso = (temasReuniao: ReadonlyArray<TemaReuniaoEnum>) => {
    return (
      !isEmpty(temasReuniao) && temasReuniao.includes(TemaReuniaoEnum.DISCUSSAO_DE_CASO_PROJETO_TERAPEUTICO_SINGULAR)
    )
  }

  return (
    <HistoricoGapPanel
      idadeOrigemAtendimento={idadeOrigemAtendimento}
      informacoesAdministrativas={mountInfosAdministrativasAtividadeColetiva(atividadeColetiva)}
    >
      <VFlow vSpacing={0.5}>
        <Heading level={3}>Atividade</Heading>
        <Text>{tipoAtividadeRecord[atividadeColetiva.tipoAtividade]}</Text>
        {hasTemaDiscussaoDeCaso(atividadeColetiva.temasReuniao) && (
          <VFlow vSpacing={0.1}>
            <Heading level={5}>Tema da reunião</Heading>
            <Text>{temaReuniaoRecord[TemaReuniaoEnum.DISCUSSAO_DE_CASO_PROJETO_TERAPEUTICO_SINGULAR]}</Text>
          </VFlow>
        )}
        {atividadeColetiva.observacaoCidadao?.observacao && (
          <TableBox css={styles.tableBoxObservacoes}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeader>
                    <Text fontWeight='bold'>Observação sobre cidadão</Text>
                  </TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell style={styles.tableCellObservacoes}>
                    <Text
                      dangerouslySetInnerHTML={{
                        __html: atividadeColetiva.observacaoCidadao.observacao,
                      }}
                      style={styles.breakWord}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableBox>
        )}
      </VFlow>
    </HistoricoGapPanel>
  )
}

const styles = {
  tableCellObservacoes: css`
    padding: 0.8rem;
  `,
  tableBoxObservacoes: css`
    margin: 1rem 0 0 0;
  `,
  breakWord: css`
    word-break: break-word;
  `,
}
